import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../../context-role-element';

export default {
  [CONTEXT.REGISTER_PAGE]: {
    [ROLE.FORM]: [ELEMENT.REGISTER],
  },
  [CONTEXT.COMPLETE_REGISTER_PAGE]: {
    [ROLE.FORM]: [ELEMENT.REGISTER],
  },
} as TValidTestId;
